import { render, staticRenderFns } from "./RegisterProductoUsuarioV.vue?vue&type=template&id=372ec67e"
import script from "./RegisterProductoUsuarioV.vue?vue&type=script&lang=js"
export * from "./RegisterProductoUsuarioV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports